import { ContactRole } from "../user-management/types";
import PagedResponse from "@/types/sv-data/PagedResponse";

export interface UserContactDetailsPagedResponse extends PagedResponse {
	pageNumber: number;
	pageSize: number;
	totalRecords: number;
	data: UserContactDetails[];
}

export interface UserContactDetails {
	userId: number;
	fullName: string;
	groupID: number;
	email: string;
	telephone: string;
	groupSyncID?: number;
	eventTaskID?: string;
}

export interface UserContactDetailsRequest {
	contactRoleId: number,
	groupId: number,
	pageNumber: number,
	pageSize: number,
}

export interface TasksState {
	// @refactor move to event state
	Tasks: Task[]; // TaskGroup[]; // event-specific, @refactor EventTasks
	TaskTypes: TaskType[];
	TaskCategories: any[];
	TaskLibrary: any[]; // @refactor ActionLibrary
	ActionPlans: any[];
	ToggleActionListModal: boolean;
	OutstandingRequiredTasks: Task[];
	NotificationServers: any[];
	EditTriggerAction: any;
	CallContacts: UserContactDetailsPagedResponse;
	DynamicDataList: any[];
	DynamicData: IDynamicData[];
	ScriptCategoryLinks: ScriptCategoryLink[];
}

export interface TaskGroup {
	isNew: boolean;
	tasks: Task[];
	title: string;
}

export interface TaskType {
	description: string;
	taskTypeID: number;
	title: string;
	taskData: object;
	titleTextFormat: string;
	componentFile: string;
}

export interface TaskCategory {
	taskCategoryID: number;
	title: string;
	tasks: Task[];
	groupId?: number;
	selected?: boolean;
}

export interface Task {
	assignedToGroupID?: number | null;
	assignedToUserID?: number | null;
	assignedToEventUserID?: string | null;
	completed: boolean;
	eventID?: number;
	eventTaskID: string;
	isMine: boolean;
	required: boolean;
	result: string | null;
	taskCategoryTitle: string;
	taskID?: number | null;
	taskText: string;
	taskTypeID?: number | null;
	taskData: object;
}

export enum ActionPlanCategory {
	Alarm = 1,
	Assessment = 2,
	Dispatch = 3
}

export enum TaskTypes {
	Basic = 1,
	URL = 5,
	MassNotification = 6,
	SitRep = 9,
	EventOutcome = 16
}

/**
 * Represents the association between a script (action plan) and a task (action library item).
 */
export interface ActionPlanTaskScript {
	order: number;
	required: boolean;
}

/**
 * Represents a task that is part of an action plan/script.
 */
export interface ActionPlanTask {
	taskCategoryID: number;
	taskID: number;
	taskText: string;
	taskData: any;
	taskTypeID: number;
	eventTaskID: string;

	triggeredTaskCount?: number;
	scripts?: { [scriptId: number]: ActionPlanTaskScript };
	selected?: boolean;

	completed?: boolean;

	eventID?: number;
	result?: string;

	scriptCategoryLink?: ScriptCategoryLink;
	order?: number;

	isMine: boolean;
	groupID?: number;
}

/**
 * Represents an Event Task - a task that is part of an event.
 */
export interface EventTask {
	eventTaskID: string;
	eventID: number;
	taskID?: number | null;
	taskTypeID?: number | null;
	taskCategoryTitle: string;
	taskText: string;
	taskData: any;

	assignedToEventUserID?: string | null;
	assignedToGroupID?: number | null;

	required: boolean;
	isMine: boolean;
	completed: boolean;
	result: string | null;
	associatedLabelIds?: number[] | null;
}

export interface IDynamicData {
	DataTypeID: number,
	Value: string,
	DataTypeId: string
}

export interface CallContactPayload
{
	GroupId: number;
	Parent: boolean;
	CallType: string;
	EventTaskId: string;
	value: ContactRole | any;
}

export interface ActionPlan {
	scriptID: number,
	groupID?: number,
	title: string,
}

export interface ScriptCategoryLink {
	scriptId: number,
	taskCategoryId: number,
	order: number,
}

export interface CategoryReorderRequest {
	scriptId: number,
	taskCategoryId: number,
	newOrder: number,
	previousOrder: number,
}

export type DecoratedActionCategories =  {
	[key: number]: {
		title: string,
		totalNumActions: number,
		numActionsAddedToScript: number
	}
};

export type ActionCategoriesExpandedState = {
	[key: number]: {
		[key: number]: boolean
	}
};

export type ActionPlanResultLabelTypes = {
	valuesFromManualOverride: string[],
	valuesFromActionPlan: string[],
}